export const FORM_ERRORS = {
    REQUIRED: 'Please fill in this field.',
    ICON_REQUIRED: 'Please select an icon.',
    UNIQUE_FLAG_KEY: 'Please enter a unique flag key.',
    UNIQUE_FLAG_NAME: 'Please enter a unique flag name.',
    UNIQUE_PROJECT_NAME: 'Please enter a unique project name.',
    UNIQUE_GROUP_NAME: 'Please enter a unique group name.',
    UNIQUE_ENVIRONMENT_NAME: 'Please enter a unique environment name.',
    UNIQUE_EMAIL: 'You have already added this email.',
    AT_LEAST_ONE_PROJECT_OWNER_REQUIRED: 'At least one project owner is required.'
};

export const GET_ERRORS = {
    PROJECT_ID: 'Error getting project id. Please try again later.',
    ENVIRONMENT_DETAILS: 'Error getting environment details. Please try again later.'
};

export const PUBLISH_MESSAGES = {
    PUBLISH_FLAGS_FAILED: 'Failed to publish flags. Please try again later.',
    PUBLISH_FLAGS_SUCCESSFUL: 'Successfully published flags.',
    PUBLISH_ENVIRONMENTS_SUCCESSFUL:
        'Default environments successfully published. Please click on your new project to continue.',
    PUBLISH_ENVIRONMENTS_FAILED: 'Failed to publish default environments. Please try again later.',
    NO_ENV: 'Please create an environment before creating feature flags.'
};

export const SUCCESS_MESSAGES = {
    ADD_GROUP: 'Successfully added new group.'
};

export const FLAG_MESSAGES = {
    GET_FLAGS_FAILED: 'Failed to fetch feature flags. Please try again later.',
    GET_FLAGS_OR_ENV_FAILED: 'Failed to fetch feature flags or environments. Please try again later.'
};

export const MEMBER_MESSAGES = {
    GET_MEMBERS_FAILED: 'Failed to fetch users in this project. Please try again later.',
    ADD_MEMBER_FAILED: 'Failed to add user to project. Please try again later.',
    DELETE_MEMBER_FAILED: 'Failed to delete member. Please try again later.',
    LEAVE_PROJECT_FAILED: 'Failed to leave project. Please try again later.',
    UPDATE_ROLE_FAILED: 'Failed to update role. Please try again later.',
    USER_DOES_NOT_EXIST: 'User does not exist. Please ask user to signup before adding them to this project.',
    USER_EXISTS_ALREADY: `Cannot add user as they are already a member/owner of this project.`
};

export const PROJECT_MESSAGES = {
    DELETE_ENVIRONMENT_FAILED: 'Error deleting environment. Please try again later.',
    DELETE_LABEL_FAILED: 'Failed to delete label. Please try again later.',
    LOAD_PROJECTS_FAILED: 'Failed to load projects. Please try again later.',
    ADD_PROJECT_FAILED: `Failed to create new project. Please try again later.`,
    ADD_ENVIRONMENT_FAILED: 'Failed to create environment. Please try again later.',
    ADD_LABEL_FAILED: 'Failed to create label. Please try again later.',
    LOAD_PROJECT_SETTINGS_FAILED: 'Unable to retrieve project settings. Please try again later.',
    LOAD_GROUP_ENVIRONMENTS_FAILED: 'Failed to get environments for this group. Please try again later.',
    SETUP_PAGE_LOAD_FAILED: 'Failed to get environments for this project. Please try again later.',
    UPDATE_ENVIRONMENT_FAILED: 'Failed to update environment. Please try again later.',
    UPDATE_LABEL_FAILED: 'Failed to update label. Please try again later.',
    GET_PROJECT_NAME_FAILED: 'Error fetching project name. Please try again later.',
    UPDATE_PROJECT_ICON_FAILED: 'Failed to update project icon. Please try again later.',
    DELETE_PROJECT_FAILED: 'Failed to delete this project. Please try again later.',
    ADD_PROJECT_GROUP: 'Failed to add group. Please try again later.',
    DELETE_PROJECT_GROUP: 'Failed to delete group. Please try again later.',
    UPDATE_PROJECT_GROUP: 'Failed to update group. Please try again later.',
    SET_USER_THEME: 'Unable to save light/dark mode. Please try again later.'
};
